import React, { useEffect, useMemo, useState } from "react";
import styles from "./index.module.css";
import { message, Switch } from "antd";
import eventBus from "Bus";
import { downloadFile } from "Common/common";
import { track } from "statsig";
import { STATSIG, PAGE } from "statsig/events";

const ApplicationSetting = () => {
  let token = sessionStorage.getItem("ZeitroA");
  let configurations = JSON.parse(localStorage.getItem("configurations") || '{}');
  
  const [setting, setSetting] = useState({
    enableLenderLoanInformation: configurations?.enableLenderLoanInformation,
    enableDispositionNotification: configurations?.enableDispositionNotification,
  });

  useEffect(() => {
    track(STATSIG.COMMON.VIEW, PAGE.APPLICATION_SETTING, { page: PAGE.APPLICATION_SETTING });
  }, []);

  const successMessage = (content = "Application setting updated. ") => {
    message.destroy();
    message.success({
      content,
      className: styles.successMessage,
    });
  };

  const onChange = async (params, tips) => {
    const value= { ...setting, ...params };
    setSetting(value);
    const response = await fetch("/los/setapplicationsettings", {
      method: "POST",
      body: JSON.stringify(value),
      headers: {
        Cache: "no-cache",
        Authorization: "Bearer " + token,
      },
    });
    if (response.status !== 200 || !response) {
      return;
    }
    const result = await response.json();
    if (result.status === "OK") {
      successMessage(tips);
      // 更新本地存储的配置（在App.js页面，暂无法存储redux）
      eventBus.emit("updateConfigurations");
      const key = Object.keys(params)[0];
      const enabled = params[key] ? "true" : "false";
      if (key === "enableLenderLoanInformation") {
        track(STATSIG.APP_SETTING.LENDER_LOAN_INFO_SWITCH, enabled, { enabled });
      } else if (key === "enableDispositionNotification") {
        track(STATSIG.APP_SETTING.DISPOSITION_NOTIFICATION_SWITCH, enabled, { enabled });
      }
    }
  };

  const list = useMemo(
    () => [
      {
        title: "Enable Lender Loan Information(L1–L4)",
        description:
          "This adds lender-specific sections (L1–L4) after the standard 1003 form. When enabled, the lender-specific sections (L1–L4) will appear after Section 9 and can be included when exporting the PDF.",
        link: "Download sample L1–L4 form (PDF)",
        key: "enableLenderLoanInformation",
        onLinkClick: () => {
          track(STATSIG.APP_SETTING.DOWNLOAD_SAMPLE_L1_L4);
          downloadFile("/LenderLoanInformation.pdf", "LenderLoanInformation.pdf");
        },
        value: setting.enableLenderLoanInformation,
        successTips:'Application settings updated: L1–L4 sections will now appear after Section 9',
        closeTips:'Application settings updated: L1–L4 sections are now hidden after Section 9',
        onChange,
      },
      {
        title: "Enable Disposition Notification ",
        description:
          "When enabled, the system will automatically send disposition reminders at 60 and 90 days after the application submission date. If there's an active pre-approval letter, loan officers can enter its expiration date to receive a reminder at that time again.",
        value: setting.enableDispositionNotification,
        key: "enableDispositionNotification",
        successTips:' Application setting updated: Disposition reminders will now send at 60 & 90 days.',
        closeTips:' Application setting updated: Disposition reminders are now disabled.',
        onChange,
      },
    ],
    [setting]
  );

  return (
    <div className={styles.applicationSetting}>
      <div className={styles.title}>Application Setting</div>
      <div className={styles.tips}>
        Manage your loan application forms and customization options for all
        users in your organization.{" "}
      </div>
      {list.map((item, index) => (
        <div key={index} className={styles.item}>
          <div className={styles.label}>
            {item.title}
            <Switch
              checked={item.value}
              onChange={(e) => item.onChange({ [item.key]: e },e?item.successTips:item.closeTips)}
            />
          </div>
          <div className={styles.value}>
            {item.description}
            {item.link && (
              <div className={styles.link} onClick={item.onLinkClick}>
                {item.link}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
export default ApplicationSetting;
